import { BrowserOptions, ErrorEvent, EventHint } from '@sentry/react';
import { getEnvironment } from 'shared/utils/environment/determineEnvironment';
import { isSentryDebuggingEnabled } from 'shared/utils/environment/variables';

const PRODUCT_FRUITS_HOST = 'productfruits.com';

/**
 * An error thrown by Product Fruits: its request is to their host, its message
 * names their host, e.g. `Load failed (app.productfruits.com)`, or its code is
 * on their host. Breadcrumbs are not read: those of the whole session hold
 * requests of Product Fruits too, and would drop errors of the app. A message
 * the app logs about Product Fruits ("Product Fruits … disabling") is kept:
 * it tells a real bug of Product Fruits.
 */
export function isProductFruitsError(event: ErrorEvent): boolean {
  if (event.request?.url?.includes(PRODUCT_FRUITS_HOST)) {
    return true;
  }
  return (event.exception?.values ?? []).some(
    ({ value, stacktrace }) =>
      value?.includes(PRODUCT_FRUITS_HOST) ||
      stacktrace?.frames?.some(({ filename }) => filename?.includes(PRODUCT_FRUITS_HOST))
  );
}

export const getSentryConfig = (
  applicationType: 'React' | 'ServiceWorker',
  version: string
): BrowserOptions => {
  return {
    dsn: 'https://c63f66769a6f478f93949b84ea43edab@o455099.ingest.sentry.io/5446110',
    environment: getEnvironment(),
    debug: isSentryDebuggingEnabled(),
    initialScope: {
      tags: { applicationType },
    },
    release: `react@${version}`,
    enableLogs: true,
    beforeSend: (event: ErrorEvent, hint?: EventHint) => {
      if (isProductFruitsError(event)) {
        return null;
      }
      return event;
    },
  };
};
